import type { VisitorRecord } from "@/hooks/useVisitorTracker";

interface VisitorTableProps {
  visitors: VisitorRecord[];
}

const FLAG_BASE = "https://flagcdn.com/24x18";

function formatTime(ts: number): string {
  const d = new Date(ts);
  return d.toLocaleString("zh-CN", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });
}

function getDeviceType(ua: string): string {
  if (/mobile/i.test(ua)) return "手机";
  if (/tablet|ipad/i.test(ua)) return "平板";
  return "桌面端";
}

function getBrowser(ua: string): string {
  if (/edg/i.test(ua)) return "Edge";
  if (/chrome/i.test(ua)) return "Chrome";
  if (/safari/i.test(ua)) return "Safari";
  if (/firefox/i.test(ua)) return "Firefox";
  return "其他";
}

export default function VisitorTable({ visitors }: VisitorTableProps) {
  const sorted = [...visitors].sort((a, b) => b.timestamp - a.timestamp);

  if (sorted.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-16 text-[#3a5070]">
        <i className="ri-user-search-line text-5xl mb-3"></i>
        <p className="text-sm">暂无访客记录</p>
      </div>
    );
  }

  return (
    <div className="overflow-x-auto">
      <table className="w-full text-sm">
        <thead>
          <tr className="text-[#5a7a9a] border-b border-[#1e2d4a]">
            <th className="text-left py-3 px-4 font-medium">时间</th>
            <th className="text-left py-3 px-4 font-medium">IP 地址</th>
            <th className="text-left py-3 px-4 font-medium">国家/地区</th>
            <th className="text-left py-3 px-4 font-medium">城市</th>
            <th className="text-left py-3 px-4 font-medium">设备</th>
            <th className="text-left py-3 px-4 font-medium">浏览器</th>
          </tr>
        </thead>
        <tbody>
          {sorted.map((v) => (
            <tr
              key={v.id}
              className="border-b border-[#111d33] hover:bg-[#0a1628] transition-colors"
            >
              <td className="py-3 px-4 text-[#7a9ab8] whitespace-nowrap">{formatTime(v.timestamp)}</td>
              <td className="py-3 px-4 text-[#4fc3f7] font-mono">{v.ip}</td>
              <td className="py-3 px-4">
                <span className="flex items-center gap-2">
                  <img
                    src={`${FLAG_BASE}/${v.countryCode.toLowerCase()}.png`}
                    alt={v.country}
                    className="w-5 h-[15px] rounded-sm object-cover"
                    onError={(e) => {
                      (e.target as HTMLImageElement).style.display = "none";
                    }}
                  />
                  <span className="text-[#c8dde8]">{v.country}</span>
                </span>
              </td>
              <td className="py-3 px-4 text-[#8aaec8]">{v.city}</td>
              <td className="py-3 px-4">
                <span className="text-xs px-2 py-0.5 rounded-full bg-[#0a1628] text-[#4fc3f7] border border-[#1e3a5a]">
                  {getDeviceType(v.userAgent)}
                </span>
              </td>
              <td className="py-3 px-4 text-[#8aaec8]">{getBrowser(v.userAgent)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
